import React, { useEffect } from 'react';
import { useSetRecoilState, useRecoilValue  } from 'recoil';
import PropTypes from 'prop-types';

import { userInfoState } from '@fo-recoil/common/user/atom';
import { getIsLogin } from '@fo-recoil/common/user/selector';
import { withCartBadgeCount, withCouponCount, withPoint } from '@fo-recoil/order/selector';
import { getIsPointUse, getIsEventMall, getIsCouponMenuUse } from '@fo-recoil/system/selector';
import myAssetPointApi from '@fo-apis/myPage/myAssetPointApi';
import couponApi from '@fo-apis/coupon/couponApi';
import authApi from '@fo-apis/common/authApi';
import orderApi from '@fo-apis/order/orderApi';
import isEmpty from 'lodash-es/isEmpty';
import useSiteInfo from '@fo-hooks/common/useSiteInfo';

const UserInfoProvider = ({ children }) => {
  const setMemberInfo = useSetRecoilState(userInfoState);
  const { isMultimall } = useSiteInfo();
  const login = useRecoilValue(getIsLogin);
  
  useEffect(() => {
    (async () => {
      const { result } = await authApi.info();
      setMemberInfo(result);
      if(login &&!isMultimall && isEmpty(result.employNumber)) {
        authApi.updateMemberInfo();
      }
    })();
  }, [setMemberInfo, login]);

  const setCartBadgeCount = useSetRecoilState(withCartBadgeCount);
  const setPoint = useSetRecoilState(withPoint);
  const setCouponCount = useSetRecoilState(withCouponCount);
  const isEventMall = useRecoilValue(getIsEventMall);
  const isPointUse = useRecoilValue(getIsPointUse);
  const isCouponMenuUse = useRecoilValue(getIsCouponMenuUse);


  useEffect(() => {
    (async () => {
      
      if(login) {
      const { result } = await orderApi.getCartCount();
      setCartBadgeCount(result);
      if(isEventMall) {
        if(isPointUse) {
          const { result } = await myAssetPointApi.summary();
          setPoint(result.filter(({assetResourceDivisionCode})=> assetResourceDivisionCode === '24')[0]);
        }
        if(isCouponMenuUse) {
          const { result : result1 } = await couponApi.getMyCouponListCount();
          setCouponCount(result1);
        }
      }
    }
    })();
  }, [setCartBadgeCount, setPoint, setCouponCount, login]);

  return <>{children}</>;
};

export default UserInfoProvider;

UserInfoProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
